import { PlannerValidation, ProductType, InteriorComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class RestrictInteriorsInCornerSolutionsValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictInteriorsInCornerSolutionsValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        const cornerSolutions = this.isCornerSolution(snapActionCandidate);
        const addonCornerFrame = this.coreApi.entities.isProductType(snapActionCandidate.host, ProductType.PAX_ADD_ON_CORNER_FRAME);
        if (addonCornerFrame || !entity.hasComponent(InteriorComponent.id)) {
            return this.validationOK();
        }
        if (cornerSolutions?.length > 0) {
            if (this.coreApi.entities.isProductType(snapActionCandidate.host, ProductType.PAX_L_DIVIDER)) {
                return this.validateLDividerSnap(snapActionCandidate);
            }
            if (!this.validComponents(entity)) {
                return this.validationFail('Entity not allowed in corner solution');
            }
            if (this.coreApi.entities.isProductType(snapActionCandidate.host, ProductType.PAX_FRAME)) {
                const hasLdivider = this.coreApi.entities.getDescendantsWithProductType(cornerSolutions[0], ProductType.PAX_L_DIVIDER);
                if (hasLdivider.length > 0) {
                    return this.validateLDividerSnap(snapActionCandidate);
                }
            }
            if (this.coreApi.entities.isProductType(entity, ProductType.PAX_L_DIVIDER)) {
                return this.validateLDivider(entity, this.coreApi.entities.isMirrored(cornerSolutions[0]));
            }
        }
        return this.validationOK();
    }
    validateLDivider(entity, isMirrordCornerSolution) {
        const guestConnections = entity.getComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID)?.connections;
        const foundOutside = guestConnections?.find(element => element.hostConnector.key.includes('left-outer-holes') ||
            element.hostConnector.key.includes('right-outer-holes'));
        if (foundOutside) {
            return this.validationFail('No l-divider with children outside can be added to corner solution');
        }
        const isMirroredLdivider = this.coreApi.entities.isMirrored(entity);
        if (isMirrordCornerSolution && !isMirroredLdivider) {
            return this.validationFail('L-divider not allowed in mirrored corner solution');
        }
        else if (!isMirrordCornerSolution && isMirroredLdivider) {
            return this.validationFail('Mirrored L-divider not allowed in normal corner solution');
        }
        return this.validationOK();
    }
    validateLDividerSnap(snapActionCandidate) {
        if (snapActionCandidate.hostConnector.key.includes('left-outer-holes') ||
            snapActionCandidate.hostConnector.key.includes('right-outer-holes') ||
            snapActionCandidate.hostConnector.key.includes('accessories-skubb-case-bottom-aside-left') ||
            snapActionCandidate.hostConnector.key.includes('accessories-skubb-case-bottom-aside-right') ||
            snapActionCandidate.hostConnector.key.includes('skubb-case-left-bottom') ||
            snapActionCandidate.hostConnector.key.includes('skubb-case-right-bottom')) {
            return this.validationFail('Connections on the outside of L-Dividers in corner solutions is not allowed');
        }
        return this.validationOK();
    }
    isCornerSolution(snapActionCandidate) {
        return this.coreApi.entities.getAncestorsWithProductType(snapActionCandidate.host, ProductType.PAX_CORNER_SOLUTION_ASM);
    }
    validComponents(entity) {
        if (entity.hasComponent(ComponentIds.PROPPING_COMPONENT_ID))
            return true;
        return this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.PAX_CLOTH_RAIL_350,
            ProductType.PAX_CLOTH_RAIL_580,
            ProductType.PAX_SHELF,
            ProductType.PAX_GLASS_SHELF,
            ProductType.PAX_SHOE_SHELF,
            ProductType.PAX_INNER_LIGHT,
            ProductType.PAX_OUTER_LIGHT,
            ProductType.PAX_VALET_HANGER,
            ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
            ProductType.PAX_L_DIVIDER,
            ProductType.PAX_SKUBB_SHOE_BOXES,
            ProductType.PAX_SKUBB_STORAGE_CASES,
            ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
            ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
            ProductType.PAX_SKUBB_STORAGE_BOXES,
            ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
            ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
            ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
            ProductType.PAX_SKUBB_HANGING_STORAGE,
            ProductType.PAX_HINGE_DOOR,
            ProductType.PAX_HINGE_DOOR_ASM
        ]);
    }
}
//# sourceMappingURL=RestrictInteriorsInCornerSolutionsValidation.js.map